import React from "react";
import { X } from "react-feather";
import { Button } from "reactstrap";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { useSelector } from "react-redux";

import { filtersArray, getCompanyNameIfTryAndBuy } from "../../utilities";
import { filterValues, isoCountries } from "../../constants";

import { LeftArrow, RightArrow } from "./arrows";
import usePreventBodyScroll from "./usePreventBodyScroll";
import "react-horizontal-scrolling-menu/dist/styles.css";

const HorizontalFilters = (props) => {
  const campaigns = useSelector((state) => state.videoPageStates.campaigns);

  const platformName = {
    Youtube: "YouTube",
    Tiktok: "TikTok",
  };

  const selectedFilters = filtersArray(props.filters);
  const { disableScroll, enableScroll } = usePreventBodyScroll();

  function onWheel(apiObj, ev) {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

    if (isThouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  }

  if (selectedFilters.length === 0) return null;

  const findObjectById = (array, id) => {
    return array?.find((obj) => obj._id === id);
  };

  return (
    <>
      <div className="IndexSelectedFiltersHeading">Filters</div>
      <div
        className="IndexSelectedFilters mb-1"
        onMouseEnter={disableScroll}
        onMouseLeave={enableScroll}
      >
        <ScrollMenu
          LeftArrow={LeftArrow}
          RightArrow={RightArrow}
          onWheel={onWheel}
        >
          {selectedFilters.map(({ key, value, subKey }) => (
            <Button.Ripple
              className="m-1"
              outline
              color="primary"
              size="md"
              key={value}
              style={{ width: "max-content" }}
              onClick={props.dismissFilter(key, value, subKey)}
            >
              <div className="d-flex">
                {value?.includes("Campaign-") ? (
                  <div style={{ color: "#000000" }}>
                    {findObjectById(campaigns, value?.split("-")[1])?.name}
                  </div>
                ) : (
                  <div style={{ color: "#000000" }}>
                    {filterValues[value] ||
                      isoCountries[value] ||
                      platformName[value] ||
                      getCompanyNameIfTryAndBuy(value)}
                  </div>
                )}
                <div className="ms-1 align-self-center">
                  <X size={15} color="#000000" />
                </div>
              </div>
            </Button.Ripple>
          ))}
        </ScrollMenu>
      </div>
    </>
  );
};

export default HorizontalFilters;
